(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  var cdEl = drawer.querySelector('[data-roar-checkout-details]'); var checkoutDetails = cdEl ? cdEl.innerHTML : '';

  // Preserve the snippet's scoped styles when replacing the drawer body.
  var bannerStyle = drawer.querySelector('[data-roar-vip-banner-styles]');
  var bannerStyles = bannerStyle ? bannerStyle.outerHTML : '';

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function openDrawer(e) {
    if (e) e.preventDefault();
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }


  function cartHasTc(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      var t = String(item.product_type || '') + ' ' + String(item.product_title || '') + ' ' + String(item.title || '');
      return /throttle/i.test(t) ||
        String(item.handle || '').toLowerCase().indexOf('throttle-controller') !== -1 ||
        String(item.sku || '').slice(0, 8) === 'RPETCCPT';
    });
  }
  function vipBannerHtml(cart) {
    if (drawer.getAttribute('data-roar-customer') !== '0' || !cart || !cart.item_count || !cartHasTc(cart)) return '';
    return '<div class="roar-vip-banner">' +
      '<p class="roar-vip-banner__text">Throttle controller special: $169, <span class="roar-normally">normally $229</span>, applied automatically. Join the Roar VIP club free for future offers.</p>' +
      '<a class="roar-vip-banner__button" href="/account/register?return_url=/cart">Join free</a></div>';
  }

  function vipHtml(cart) {
    if (!cart || !cart.item_count) return '';
    return '<div class="roar-drawer__vip roar-ship-note"><p class="roar-drawer__tc-ship">Shipping, taxes and discount codes are calculated at checkout. <a href="/policies/refund-policy" style="color:#C17A4A">Returns policy</a></p></div>';
  }

  function emptyHtml() {
    return bannerStyles + vipHtml(null) + '<div class="roar-drawer__empty"><p>Your cart is currently empty.</p><a class="roar-cart__continue" href="/collections/all">Continue shopping</a></div>';
  }

  function itemHtml(item) {
    var img = item.image ? '<a href="' + item.url + '"><img src="' + item.image + '" alt=""></a>' : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="roar-cart__variant">' + item.variant_title + '</div>' : '';
    return (
      '<li class="roar-drawer__item" data-key="' + item.key + '">' +
        img +
        '<div><a href="' + item.url + '">' + item.product_title + '</a>' + variant +
        '<div class="roar-cart__qty">' +
          '<button type="button" data-roar-qty="-1" data-key="' + item.key + '">−</button>' +
          '<input type="number" value="' + item.quantity + '" min="0" data-key="' + item.key + '" aria-label="Quantity">' +
          '<button type="button" data-roar-qty="1" data-key="' + item.key + '">+</button>' +
        '</div>' +
        '<button type="button" class="roar-cart__remove" data-roar-qty="0" data-key="' + item.key + '">Remove</button></div>' +
        '<div class="roar-cart__item-total">' + money(item.final_line_price) + '</div>' +
      '</li>'
    );
  }

  function render(cart) {
    setCount(cart.item_count);
    var body = drawer.querySelector('[data-roar-cart-body]');
    if (!cart.item_count) {
      body.innerHTML = emptyHtml();
      return;
    }
    body.innerHTML =
      bannerStyles + vipBannerHtml(cart) +
      '<form id="CartDrawerForm" action="/cart" method="post" novalidate>' +
        '<ul class="roar-drawer__list">' + cart.items.map(itemHtml).join('') + '</ul>' +
        '<div class="roar-drawer__foot">' + vipHtml(cart) +
          '<div class="roar-cart__sub"><span>Subtotal</span><span data-roar-subtotal>' + money(cart.total_price) + '</span></div>' +
          '<a class="roar-cart__btn roar-cart__btn--checkout" href="/checkout">Check out</a>' + checkoutDetails +
          '<a class="roar-drawer__view" href="/cart">View cart</a>' +
        '</div>' +
      '</form>';
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-roar-cart-open]')) openDrawer(e);
    if (e.target.closest('[data-roar-cart-close]')) closeDrawer();
    var qtyBtn = e.target.closest('[data-roar-qty]');
    if (qtyBtn && drawer.contains(qtyBtn)) {
      var key = qtyBtn.getAttribute('data-key');
      var delta = qtyBtn.getAttribute('data-roar-qty');
      var row = qtyBtn.closest('li[data-key]');
      var input = row ? row.querySelector('input[type="number"]') : null;
      var next = delta === '0' ? 0 : Math.max(0, Number(input.value || 0) + Number(delta));
      change(key, next);
    }
    var megaTrig = e.target.closest('[data-roar-mega-trigger]');
    if (megaTrig && window.matchMedia('(max-width: 980px)').matches) {
      e.preventDefault();
      var panel = megaTrig.parentElement.querySelector('[data-roar-mega-panel]');
      if (panel) panel.hidden = !panel.hidden;
    }
    var navBtn = e.target.closest('[data-roar-nav-toggle]');
    if (navBtn) {
      var nav = document.getElementById('RoarNav');
      nav.classList.toggle('is-open');
      navBtn.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
    }
  });

  drawer.addEventListener('change', function (e) {
    var input = e.target.closest('input[type="number"][data-key]');
    if (!input) return;
    change(input.getAttribute('data-key'), Math.max(0, Number(input.value || 0)));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  document.addEventListener('roar:cart:refresh', function () {
    getCart().then(render);
  });
})();
